import {get} from '../utils/http';
import Ticket from '../models/Ticket';

// 获取city和poi相关的推荐`ticket`
export function getRecommended(city_ids, poi_uids) {
  let url = '/m/v2/?m=api/ticket/get_by_poi_uid_and_city';

  return get(url, {
    data: {city_ids, poi_uids}
  }).then(function (data) {
    data = data.tickets;
    data.list = data.list.map(function (item) {
      return Ticket.parseInput(item);
    });

    return data;
  });
}




// WEBPACK FOOTER //
// ./src/services/ticket.js